import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
const ChannelDetails = (props) => {
  const { channel, tabValue } = props;

  return (
    <div className='row mx-4 mt-4'>
      {tabValue === 0 && (
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Channel Name</div>
            <div className='details-value preview-breaks'>{channel.name}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Category Name</div>
            <div className='details-value'>{channel.categoryName}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Channel Code</div>
            <div className='details-value'>{channel.code}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Channel Number</div>
            <div className='details-value'>{channel.number}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Language</div>
            <div className='details-value'>{channel.language}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>DRM</div>
            <div className='details-value'>{channel.isDRM ? 'Yes' : 'No'}</div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Bouquets</div>
            <div className='details-value'>
              {channel?.bouquet?.map((item) => item.name).join(', ')}
            </div>
          </div>
          {channel.tvType === 'IPTV' && (
            <>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>IP Address</div>
                <div className='details-value'>{channel.iptv?.url}</div>
              </div>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>Port</div>
                <div className='details-value'>{channel.iptv?.port}</div>
              </div>
            </>
          )}
          {channel.tvType !== 'IPTV' && (
            <>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>Channel Type</div>
                <div className='details-value'>
                  {channel.coaxial?.digitalTelevisionFormat?.toUpperCase()}
                </div>
              </div>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>Frequency</div>
                <div className='details-value'>{channel.coaxial?.frequency}</div>
              </div>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>Broadcast Standard</div>
                <div className='details-value'>{channel.coaxial?.broadCastStandard}</div>
              </div>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>Modulation Type</div>
                <div className='details-value'>{channel.coaxial?.modulationType}</div>
              </div>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>Bandwidth</div>
                <div className='details-value'>{channel.coaxial?.bandwidth}</div>
              </div>
              {channel.coaxial?.digitalTelevisionFormat === 'sdtv' && (
                <div className='col-md-6 mt-4'>
                  <div className='details-label'>Satellite ID</div>
                  <div className='details-value'>{channel.coaxial?.satelliteId}</div>
                </div>
              )}
              <div className='col-md-6 mt-4'>
                <div className='details-label'>Program Number</div>
                <div className='details-value'>{channel.coaxial?.programNumber}</div>
              </div>
              {channel.coaxial?.digitalTelevisionFormat === 'dtv' && (
                <div className='col-md-6 mt-4'>
                  <div className='details-label'>Major Number</div>
                  <div className='details-value'>{channel.coaxial?.majorNumber}</div>
                </div>
              )}
              {channel.coaxial?.digitalTelevisionFormat === 'sdtv' && (
                <div className='col-md-6 mt-4'>
                  <div className='details-label'>Polarization</div>
                  <div className='details-value'>{channel.coaxial?.polarization}</div>
                </div>
              )}
              {channel.coaxial?.digitalTelevisionFormat === 'cdtv' && (
                <>
                  <div className='col-md-6 mt-4'>
                    <div className='details-label'>Symbol Rate</div>
                    <div className='details-value'>{channel.coaxial?.symbolRate}</div>
                  </div>
                  <div className='col-md-6 mt-4'>
                    <div className='details-label'>Major Number</div>
                    <div className='details-value'>{channel.coaxial?.majorNumber}</div>
                  </div>
                </>
              )}
            </>
          )}
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Description</div>
            <div className='details-value preview-breaks'>
              {channel.description != null && channel.description !== ''
                ? channel.description
                : '---'}
            </div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>External URL</div>
            <div className='details-value'>{channel.externalURL ? channel.externalURL : '---'}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>EPG URL</div>
            <div className='details-value'>{channel.isEpgURL ? channel.epgURL : '---'}</div>
          </div>
        </>
      )}
      {tabValue === 1 && (
        <>
          <MediaViewer
            images={channel.images}
            videos={channel.videos}
            gifs={channel.gifs}
            enabledMediaTabs={['image']}
          />
        </>
      )}
    </div>
  );
};

export default ChannelDetails;
